import { render, staticRenderFns } from "./ownermoneychangeAction.vue?vue&type=template&id=10730db1&scoped=true"
import script from "./ownermoneychangeAction.vue?vue&type=script&lang=js"
export * from "./ownermoneychangeAction.vue?vue&type=script&lang=js"
import style0 from "./ownermoneychangeAction.vue?vue&type=style&index=0&id=10730db1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10730db1",
  null
  
)

export default component.exports